import { IUseDialogData, useDialog } from 'modules/dialogs';
import { WALLET_CONNECT_DIALOG_ID } from '../const';

export const useWalletConnectModal = (): IUseDialogData =>
  useDialog(WALLET_CONNECT_DIALOG_ID);
